import React, { Component, Fragment } from 'react';
import { Label, Row, Col, Input, Table, Button, Tooltip } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

class FundDateToDateAppraisal extends Component {
    constructor(props) {
        super(props);

        const url = this.props.selector != null ? this.props.selector.split('/') : [];
        this.state = {
            isLoading: false,
            investor: (url[0] != null && url[0] !== '') ? decodeURIComponent(url[0]).replace(/\//g, '-') : '',
            startDate: (url[1] != null && url[1] !== '') ? url[1] : '',
            endDate: (url[2] != null && url[2] !== '') ? url[2] : '',
            data: [],
            sheetData: [],
            filter: {},
            investors: [],
            sort: 'fund',
            sortType: 'text',
            sortAsc: true,
            dbField: false,
            tooltipOpen: {},
            headers: [
                { display: 'Fund', accessors: ['fund'], type: 'text', filter: true, width: 64 },
                { display: 'Sector', accessors: ['sector'], type: 'text', filter: true, width: 18 },
                { display: 'Commitments', accessors: ['commitment'], hidden: true, type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Pre-Funded', accessors: ['prefunded'], hidden: true, type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Previous Balance', accessors: ['previousBalance'], type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Additions / Capital Calls', accessors: ['additions'], type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Withdrawals / Distributions', accessors: ['withdrawals'], type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Net Change in Value', accessors: ['netChange'], type: 'currency', classNames: 'text-right', width: 22 },
                { display: 'Ending Balance', accessors: ['endingBalance'], type: 'currency', classNames: 'text-right', width: 22 },
            ]
        };
        this.timeout = null;
    }

    componentDidMount() {
        this.props.log('FundDateToDateAppraisal.js/componentDidMount');
        this.getInvestors(); this.onSubmit();
        this.props.passHeaders(this.state.headers, this.callback);
    }

    callback = (headers) => {
        this.props.log('FundDateToDateAppraisal.js/callback (headers)', headers);
        this.setState({
            headers: headers
        }, () => this.getCSVdata());
    }

    getFormattedDate = (date) => {
        this.props.info('FundDateToDateAppraisal.js/getFormattedDate (date)', date);
        let year = date.getFullYear();
        let month = (1 + date.getMonth());
        let day = date.getDate();
        return month + '/' + day + '/' + year;
    }

    getFormattedField = (val, type, hide) => {
        this.props.info('FundDateToDateAppraisal.js/getFormattedField (val,type,hide)', val, type, hide);
        if (val == null || val === '') return val;
        switch (type) {
            case "date":
                return this.getFormattedDate(new Date(val.substr(0, 4), parseInt(val.substr(5, 2)) - 1, val.substr(8, 2), 0, 0, 0));
            case "number":
                return Intl.NumberFormat().format(parseFloat(val));
            case "currency":
                if (String(val).indexOf('---') > -1) return val;
                let specialChar = '';
                let className = '';
                if (String(val).indexOf('*') > -1) {
                    val = parseFloat(String(val).slice(0, -1));
                    specialChar = '*';
                    className = "text-primary"
                }
                if (String(val).indexOf('‡') > -1) {
                    val = parseFloat(String(val).slice(0, -1));
                    specialChar = '‡';
                    className = "text-info"
                }
                if (hide == null) {
                    return val >= 0 ?
                        <span className={className}>{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(val)}{specialChar}</span>
                        :
                        <span className="negative">{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                        }).format(val)}{specialChar}</span>;
                } else if (hide) {
                    return val + specialChar
                }
                break;
            default:
                val = String(val).replaceAll('_', '');
                return val;
        }
    }

    getInvestors = () => {
        this.props.log('FundDateToDateAppraisal.js/getInvestors');
        fetch('/api/reports/InvestorListings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            },
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        investors: results.data.map(item => { return (item.data != null && item.data.companyName != null) ? item.data.companyName : null })
                    });
                } else {
                    this.props.addToast('Unable to get investors.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onSubmit = () => {
        this.props.log('FundDateToDateAppraisal.js/onSubmit');
        if (this.state.investor === '' || this.state.startDate === '' || this.state.endDate === '') return;
        clearTimeout(this.timeout);
        this.setState({
            data: [],
            isLoading: true
        }, () => {
            this.timeout = setTimeout(() => {
                fetch('/api/reports/FundDateToDateAppraisal', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-DB': this.props.clientId
                    },
                    body: JSON.stringify([
                        { key: 'investor', type: 'nvarchar', value: this.state.investor },
                        { key: 'startDate', type: 'date', value: this.state.startDate },
                        { key: 'endDate', type: 'date', value: this.state.endDate }
                    ])
                })
                    .then(results => results.json())
                    .then(results => {
                        if (results.success) {
                            this.setState({
                                isLoading: false,
                                data: this.prepareData(results.data)
                            }, () => this.getCSVdata());
                        } else {
                            this.setState({
                                isLoading: false,
                            });
                            this.props.addToast('Unable to download report.', 5, 'danger');
                        }
                    })
                    .catch(() => {
                        this.props.addToast('An error has occurred.', 5, 'danger');
                    })
            }, 1000)
        })
    }

    addToMonth = (date, months) => {
        var d = new Date(new Date(date + 'T00:00:00'));
        d.setMonth(d.getMonth() + (months || 0), d.getDate());
        if (d.getMonth() === new Date(new Date(date + 'T00:00:00')).getMonth()) {
            d.setDate(d.getDate() - 1, d.getDate())
        }
        return d.toISOString().split('T')[0];
    }

    prepareData = (data) => {
        this.props.log('PEFundTransactionsAnalysis.js/prepareData');
        let retArr = [];
        let obj = {};
        data = data.map(item => {
            item.data = item.data[0];
            return item;
        });
        data.forEach(row => {
            let isZeroValuation = false;
            const sector = (row.data.sector != null ? row.data.sector : 'No Sector')
            if (obj[sector] == null) obj[sector] = [];
            row.data.preliminary = 0;
            row.data.previousBalance = 0;
            row.data.endingBalance = 0;
            row.data.additions = 0;
            row.data.withdrawals = 0;
            row.data.commitment = 0;
            row.data.prefunded = 0;
            row.data.remainingCommitment = 0;
            if (row.data.valuations != null) {
                if ([...row.data.valuations].pop().preliminaryValuation != null && [...row.data.valuations].pop().valuation == null &&
                    [...row.data.valuations].pop().month === ((new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) === 0 ? 12 : new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) &&
                    [...row.data.valuations].pop().year === new Date(this.state.endDate + 'T00:00:00').getFullYear()) {
                    row.data.endingBalance = parseFloat([...row.data.valuations].pop().preliminaryValuation);
                    this.props.log('ending balance A', row.data.fund, row.data.endingBalance);
                    row.data.preliminary = 2;
                    this.props.log('preliminary A', row.data.fund, row.data.preliminary);
                }
                if ([...row.data.valuations].pop().preliminaryValuation != null && [...row.data.valuations].pop().valuation != null &&
                    [...row.data.valuations].pop().month === ((new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) === 0 ? 12 : new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) &&
                    [...row.data.valuations].pop().year === new Date(this.state.endDate + 'T00:00:00').getFullYear()) {
                    row.data.endingBalance = parseFloat([...row.data.valuations].pop().valuation);
                    this.props.log('ending balance B', row.data.fund, row.data.endingBalance);
                    row.data.preliminary = 1;
                    this.props.log('preliminary B', row.data.fund, row.data.preliminary);
                }
                if ([...row.data.valuations].filter(valuation => valuation.preliminaryValuation != null).length > 0) {
                    row.data.preliminary += 1;
                    this.props.log('preliminary C', row.data.fund, row.data.preliminary);
                }
                row.data.valuations.forEach(valuation => {
                    let prevMonth = this.addToMonth(this.state.startDate, 0);
                    if (valuation.month === ((new Date(prevMonth + 'T00:00:00').getMonth() + 1) === 0 ? 12 : (new Date(prevMonth + 'T00:00:00').getMonth() + 1)) &&
                        valuation.year === new Date(prevMonth + 'T00:00:00').getFullYear() && valuation.valuation != null) {
                        row.data.previousBalance = parseFloat(valuation.valuation);
                        this.props.log('previous balance A', row.data.fund, row.data.previousBalance);
                    }
                    if (valuation.month === ((new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) === 0 ? 12 : new Date(this.state.endDate + 'T00:00:00').getMonth() + 1) &&
                        valuation.year === new Date(this.state.endDate + 'T00:00:00').getFullYear() && valuation.valuation != null) {
                        row.data.endingBalance = parseFloat(valuation.valuation);
                        this.props.log('ending balance C', row.data.fund, row.data.endingBalance);
                    }
                });
                if (parseFloat([...row.data.valuations].pop().valuation) === 0) {
                    isZeroValuation = true;
                    row.data.endingBalance = 0;
                    this.props.log('ending balance D', row.data.fund, row.data.endingBalance);
                }
            };
            if (row.data.transactionData != null) {
                row.data.transactionData.filter(transaction => !isNaN(transaction.amount) && transaction.amount != null).forEach(transaction => {
                    switch (transaction.type) {
                        case "Buy":
                        case "Transfer In":
                            row.data.additions += parseFloat(transaction.amount);
                            this.props.log('additions A', row.data.fund, row.data.additions);
                            // row.data.prefunded -= parseFloat(transaction.amount)
                            break;
                        case "Capital Call":
                            row.data.additions += parseFloat(transaction.amount);
                            this.props.log('additions B', row.data.fund, row.data.additions);
                            break;
                        case "Sell":
                        case "Return of Callable Capital":
                        case "Transfer Out":
                        case "Late Interest":
                            row.data.withdrawals -= parseFloat(transaction.amount);
                            this.props.log('withdrawals A', row.data.fund, row.data.withdrawals);
                            break;
                        case "Pre-Funding":
                            row.data.prefunded += parseFloat(transaction.amount)
                            this.props.log('prefunded A', row.data.fund, row.data.prefunded);
                            break;
                        case "Commitment":
                            row.data.commitment += parseFloat(transaction.amount);
                            this.props.log('commitment A', row.data.fund, row.data.commitment);
                            break;
                        case "Dividend":
                            row.data.withdrawals -= parseFloat(transaction.amount);
                            this.props.log('withdrawals B', row.data.fund, row.data.withdrawals);
                            break;
                        default:
                            break;
                    }
                    if (transaction.type === 'Buy' && row.data.prefunded === parseFloat(transaction.amount)) {
                        row.data.prefunded -= parseFloat(transaction.amount);
                        this.props.log('prefunded B', row.data.fund, row.data.prefunded);
                    }
                })
            }
            if (row.data.endingBalance === 0 && !isZeroValuation && row.data.preliminary !== 1) {
                row.data.endingBalance = parseFloat(row.data.previousBalance) + parseFloat(row.data.additions) + parseFloat(row.data.withdrawals);
                this.props.log('ending balance E', row.data.fund, row.data.endingBalance, row.data.preliminary);
            }
            if (row.data.latestValuationDelta > 60 && !isZeroValuation) {
                row.data.endingBalance = 0;
                this.props.log('ending balance F', row.data.fund, row.data.endingBalance, row.data.latestValuationDelta);
            }

            row.data.prefunded = Math.max(0, row.data.prefunded);
            this.props.log('prefunded C', row.data.fund, row.data.prefunded);
            row.data.netChange = (
                (!isNaN(row.data.endingBalance) && row.data.endingBalance != null ? parseFloat(row.data.endingBalance) : 0)
                - (!isNaN(row.data.additions) && row.data.additions != null ? parseFloat(row.data.additions) : 0)
                - (!isNaN(row.data.withdrawals) && row.data.withdrawals != null ? parseFloat(row.data.withdrawals) : 0)
                - (!isNaN(row.data.previousBalance) && row.data.previousBalance != null ? parseFloat(row.data.previousBalance) : 0)
            );
            this.props.log('net change A', row.data.fund, row.data.netChange);
            if (row.data.previousBalance == null) {
                row.data.previousBalance = 0;
                this.props.log('previous balance B', row.data.fund, row.data.previousBalance);
            }
            if (row.data.endingBalance === 0) {
                row.data.endingBalance = '---';
                this.props.log('ending balance G', row.data.fund, row.data.endingBalance);
            }
            if (row.data.preliminary === 3) {
                row.data.endingBalance += '*'
                this.props.log('ending balance H', row.data.fund, row.data.endingBalance);
            }
            if (row.data.preliminary === 1 || row.data.preliminary === 2) {
                // console.log(row.data.fund, row.data, this.state.startDate, this.state.endDate, row.data.year, parseInt(String(this.state.startDate).slice(0, 4)), row.data.month, parseInt(String(this.state.startDate).substring(5, 7)))
                if (row.data.valuations.length > 0 && row.data.valuations[0].preliminaryValuation != null && row.data.valuations[0].year === parseInt(String(this.state.startDate).slice(0, 4)) &&
                    row.data.valuations[0].month === parseInt(String(this.state.startDate).substring(5, 7))) {
                    row.data.previousBalance += '‡'
                } else {
                    row.data.endingBalance += '‡'
                }
                this.props.log('ending balance I', row.data.fund, row.data.endingBalance);
            }

            obj[sector].push(row.data)
        })

        data = data.map(row => { return ({ data: { ...row, ...row.data }, formEntryId: 0 }) })

        let totalPreviousBalance = 0;
        let totalCommitment = 0;
        let totalPrefunded = 0;
        let totalAdditions = 0;
        let totalWithdrawals = 0;
        let totalNetChange = 0;
        let totalEndingBalance = 0;
        Object.keys(obj).forEach(key => {
            obj[key].forEach(row => {
                retArr.push({ data: row })
            })
            totalPreviousBalance += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.previousBalance).replace(/[^0-9$.,-]/g, '')) && String(next.previousBalance).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.previousBalance).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalCommitment += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.commitment).replace(/[^0-9$.,-]/g, '')) && String(next.commitment).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.commitment).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalPrefunded += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.prefunded).replace(/[^0-9$.,-]/g, '')) && String(next.prefunded).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.prefunded).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalAdditions += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.additions).replace(/[^0-9$.,-]/g, '')) && String(next.additions).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.additions).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalWithdrawals += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.withdrawals).replace(/[^0-9$.,-]/g, '')) && String(next.withdrawals).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.withdrawals).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalNetChange += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.netChange).replace(/[^0-9$.,-]/g, '')) && String(next.netChange).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.netChange).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            totalEndingBalance += obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.endingBalance).replace(/[^0-9$.,-]/g, '')) && String(next.endingBalance).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.endingBalance).replace(/[^0-9$.,-]/g, '')) : 0), 0);
            retArr.push({
                data: {
                    fund: '_' + key,
                    previousBalance: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.previousBalance).replace(/[^0-9$.,-]/g, '')) && String(next.previousBalance).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.previousBalance).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    commitment: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.commitment).replace(/[^0-9$.,-]/g, '')) && String(next.commitment).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.commitment).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    prefunded: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.prefunded).replace(/[^0-9$.,-]/g, '')) && String(next.prefunded).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.prefunded).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    additions: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.additions).replace(/[^0-9$.,-]/g, '')) && String(next.additions).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.additions).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    withdrawals: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.withdrawals).replace(/[^0-9$.,-]/g, '')) && String(next.withdrawals).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.withdrawals).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    netChange: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.netChange).replace(/[^0-9$.,-]/g, '')) && String(next.netChange).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.netChange).replace(/[^0-9$.,-]/g, '')) : 0), 0),
                    endingBalance: obj[key].reduce((prev, next) => prev + parseFloat(!isNaN(String(next.endingBalance).replace(/[^0-9$.,-]/g, '')) && String(next.endingBalance).replace(/[^0-9$.,-]/g, '') != null ? parseFloat(String(next.endingBalance).replace(/[^0-9$.,-]/g, '')) : 0), 0)
                }
            })
        })
        retArr.push({
            data: {
                fund: '__Total',
                previousBalance: totalPreviousBalance,
                commitment: totalCommitment,
                prefunded: totalPrefunded,
                additions: totalAdditions,
                withdrawals: totalWithdrawals,
                netChange: totalNetChange,
                endingBalance: totalEndingBalance
            }
        })
        return retArr;
    }

    getCSVdata = () => {
        this.props.log('FundDateToDateAppraisal.js/getCSVdata');
        if (this.state.data.length === 0) {
            this.props.passData([], '');
        } else {
            const retArr = [
                ['Investor', 'Start Date', 'End Date'],
                [
                    this.state.investor,
                    this.state.startDate !== '' ? this.getFormattedDate(new Date(this.state.startDate + 'T00:00:00')) : '',
                    this.state.endDate !== '' ? this.getFormattedDate(new Date(this.state.endDate + 'T00:00:00')) : '',
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    header.display
                ))
            ]).concat(
                this.state.data.map(row => {
                    let retArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        retArray[headerIndex] = headerIndex <= 1 ? (this.getFormattedField(row.data[header.accessors[0]], header.type, true)) : parseFloat(this.getFormattedField(row.data[header.accessors[0]], header.type, true).replaceAll('---', 0));
                    });
                    return retArray;
                })
            );
            const styleArr = [
                [
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { font: { bold: true }, fill: { fgColor: { rgb: 'ffffaa' } } } }
                ],
                [
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } },
                    { s: { fill: { fgColor: { rgb: 'ffffaa' } } } }
                ],
                []
            ].concat([
                this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                    { s: { font: { bold: true } } }
                ))
            ]).concat(
                this.state.data.map(row => {
                    let styleArray = [];
                    this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).forEach((header, headerIndex) => {
                        switch (headerIndex) {
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                // any currency columns
                                if (row.data.fund.substring(0, 2) === '__') {
                                    styleArray[headerIndex] = {
                                        // total row
                                        z: '$###,##0.00', s: { font: { bold: true, color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 ? 'ffaaaa' : 'ffffff' } }, fill: { fgColor: { rgb: '343a40' } } }
                                    }
                                } else if (row.data.fund.substring(0, 1) === '_') {
                                    styleArray[headerIndex] = {
                                        // header row
                                        z: '$###,##0.00', s: { font: { bold: true, color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 ? 'ffaaaa' : 'ffffff' } }, fill: { fgColor: { rgb: '6c757d' } } }
                                    }
                                } else {
                                    styleArray[headerIndex] = {
                                        // data row
                                        z: '$###,##0.00', s: { font: { color: { rgb: parseFloat(row.data[header.accessors[0]]) < 0 && !isNaN(parseFloat(row.data[header.accessors[0]])) ? 'ff0000' : '000000' } } }
                                    };
                                }
                                break;
                            default:
                                // fund and sector columns
                                if (row.data.fund.substring(0, 2) === '__') {
                                    styleArray[headerIndex] = {
                                        // total row
                                        s: { font: { bold: true, color: { rgb: 'ffffff' } }, fill: { fgColor: { rgb: '343a40' } } }
                                    }
                                } else if (row.data.fund.substring(0, 1) === '_') {
                                    styleArray[headerIndex] = {
                                        // header row
                                        s: { font: { bold: true, color: { rgb: 'ffffff' } }, fill: { fgColor: { rgb: '6c757d' } } }
                                    }
                                } else {
                                    styleArray[headerIndex] = null
                                }
                        }
                    })
                    return styleArray;
                })
            );
            this.props.passData(retArr, "fund-date-to-date-appraisal", styleArr);
        }
    }

    onChange = (e) => {
        this.props.log('FundDateToDateAppraisal.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let value = '';
        let refresh = true;
        this.setState((prevState) => {
            let sel = prevState;
            sel[e.target.name] = (e.target.value);
            value = ((sel.investor) === '' ? '' : encodeURIComponent(sel.investor)) + '/' + ((sel.startDate) === '' ? '' : sel.startDate) + '/' + ((sel.endDate) === '' ? '' : sel.endDate);
            if (e.target.name === 'investor' && e.target.value === '0') {
                sel.investor = '';
                value = ((sel.startDate !== '') ? '/' + sel.startDate : '/') + ((sel.endDate) !== '' ? '/' + sel.endDate : '/');
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    onChangeFilter = (e) => {
        this.props.log('FundDateToDateAppraisal.js/onChangeFilter (e)', e.target.name, e.target.value);
        e.persist();
        this.setState((prevState) => {
            let sel = prevState;
            sel.filter[e.target.name] = e.target.value;
            return sel;
        })
    }

    render() {
        this.props.info('FundDateToDateAppraisal.js/render');
        return (
            <>
                <Row className="mb-4 noPrint">
                    <Col md={3} className="px-2">
                        <Label className='w-100'>Investor
                            <Input type="select" className="companySelect w-100" name="investor" value={this.props.replaceSpecialChars(this.props.isFieldNull(this.state.investor).replace(/\//g, '-'))} onChange={this.onChange}>
                                <option value="0">Show All</option>
                                {this.state.investors.map(investor => (
                                    <option key={investor} value={this.props.replaceSpecialChars(this.props.isFieldNull(investor).replace(/\//g, '-'))}>{investor}</option>
                                ))}
                            </Input>
                        </Label>
                    </Col>
                    <Col md={2} className="px-2">
                        <Label className='w-100' >Start Date
                            <Input type="date" name="startDate" value={this.props.isFieldNull(this.state.startDate)} onChange={this.onChange} />
                        </Label>
                    </Col>
                    <Col md={2} className="px-2">
                        <Label className='w-100' >End Date
                            <Input type="date" name="endDate" value={this.props.isFieldNull(this.state.endDate)} onChange={this.onChange} />
                        </Label>
                    </Col>
                    {this.state.data.filter(item => item.data.preliminary > 0).length > 0 &&
                        <Col md={5} className="text-right entryCreatedUpdated">
                            <p className='text-primary'>* indicates preliminary valuation, no final valuation</p>
                            <p className='text-info'>‡ indicates preliminary valuation(s) were entered </p>
                        </Col>
                    }
                </Row>
                {this.state.data.length > 1 ?
                    <Table>
                        <thead>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th className={'pointer ' + header.classNames}
                                        onClick={() => this.setState(this.props.setSort(header.accessors[0], header.type, this.state.sort, this.state.sortAsc, header.dbField))}
                                        key={headerIndex}>
                                        {header.display}
                                        {/* {header.accessors[0] === this.state.sort ? <span className="sortChevron">
                                            <FontAwesomeIcon icon={this.state.sortAsc ? faChevronUp : faChevronDown} />
                                        </span> : null} */}
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden)).map((header, headerIndex) => (
                                    <th key={headerIndex}>
                                        {header.filter ? <Input
                                            type="text"
                                            name={header.accessors[0]}
                                            placeholder={"Filter " + header.display}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={this.onChangeFilter}
                                            value={header.accessors[0] != null && this.state.filter[header.accessors[0]] != null ? this.state.filter[header.accessors[0]] : ''}
                                        /> : null}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.filter(entry => {
                                let temp = true;
                                Object.keys(this.state.filter).forEach(field => {
                                    if ((entry.data[field] != null && this.state.filter[field] != null &&
                                        (entry.data[field].toUpperCase().indexOf(this.state.filter[field].toUpperCase()) === -1)) ||
                                        ((this.state.filter[field] != null && this.state.filter[field] !== '') && entry.data[field] == null)) temp = false;
                                })
                                return temp;
                            }).map((row, rowIndex) => (
                                <tr key={row.formEntryId + '-' + rowIndex} className={row.data.fund.indexOf('_') > -1 ? "font-weight-bold" : ""}>
                                    {this.state.headers.filter(header => header.hidden == null || (header.hidden != null && !header.hidden))
                                        .map((header, headerIndex) => (
                                            <td className={(header.dbField
                                                ?
                                                "dbField"
                                                :
                                                "") + " " + (header.classNames) + " " +
                                                (row.data.fund.indexOf('__') > -1
                                                    ?
                                                    " pb-4 text-white bg-dark"
                                                    :
                                                    ((row.data.fund.indexOf('_') > -1 ? " pb-4 text-white bg-secondary" : "")))
                                            } key={headerIndex}>{header.dbField
                                                ?
                                                this.getFormattedField(row[header.accessors[0]], header.type)
                                                :
                                                this.getFormattedField(row.data[header.accessors[0]], header.type)}
                                                {header.accessors[0] === 'fund' && (row.data.transactionData != null || row.data.valuations != null) ?
                                                    <>
                                                        <Button color="link" className="p-0 m-0"
                                                            id={'button-' + rowIndex}
                                                        ><FontAwesomeIcon icon={faQuestionCircle} /></Button>
                                                        <Tooltip
                                                            innerClassName="tooltipInner"
                                                            placement="right"
                                                            target={'button-' + rowIndex}
                                                            trigger="click hover focus"
                                                            isOpen={this.state.tooltipOpen['button-' + rowIndex] != null ? this.state.tooltipOpen['button-' + rowIndex] : false}
                                                            toggle={() => this.setState((prevState) => {
                                                                let obj = { ...prevState };
                                                                obj.tooltipOpen['button-' + rowIndex] = (obj.tooltipOpen['button-' + rowIndex] != null ? !obj.tooltipOpen['button-' + rowIndex] : true);
                                                                return obj
                                                            })}
                                                        >
                                                            <table>
                                                                <tbody>
                                                                    {row.data.transactionData && row.data.transactionData.map((transaction, transactionIndex) => (
                                                                        <tr key={transactionIndex} className="text-left text-nowrap">
                                                                            <td className='text-right'>{transaction.type}:</td>
                                                                            <td className='text-right'>{this.getFormattedField(transaction.amount, 'currency')}</td>
                                                                            <td>({this.getFormattedDate(new Date(transaction.tradeDate + 'T00:00:00'))})</td>
                                                                        </tr>
                                                                    ))}
                                                                    {row.data.valuations && row.data.valuations.map((valuation, valuationIndex) => (
                                                                        <Fragment key={valuationIndex}>
                                                                            {(valuation.preliminaryValuation != null && parseFloat(valuation.preliminaryValuation) > -1) &&
                                                                                <tr className="text-nowrap text-left">
                                                                                    <td className='text-right'>Preliminary Valuation:</td>
                                                                                    <td className='text-right'>{this.getFormattedField(valuation.preliminaryValuation, 'currency')}</td>
                                                                                    <td>({valuation.month}/{valuation.year})</td>
                                                                                </tr>
                                                                            }
                                                                            {(valuation.valuation != null && parseFloat(valuation.valuation) > -1) &&
                                                                                <tr className="text-nowrap text-left">
                                                                                    <td className='text-right'>Valuation:</td>
                                                                                    <td className='text-right'>{this.getFormattedField(valuation.valuation, 'currency')}</td>
                                                                                    <td>({valuation.month}/{valuation.year})</td>
                                                                                </tr>
                                                                            }
                                                                        </Fragment>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Tooltip>
                                                    </>
                                                    : ''}
                                            </td>
                                        ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    : <>{this.state.isLoading ? 'Loading...' : 'No results'}</>}
            </>
        );

    }
}

export default FundDateToDateAppraisal;
